import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
export function AboutPage() {
  const milestones = [{
    year: '2009',
    title: 'Founded',
    description: 'Jibek Jolu Group was established with a vision to bring authentic Central Asian hospitality to the world.'
  }, {
    year: '2010',
    title: 'First Restaurant',
    description: 'Opened our flagship location, setting a new standard for culinary excellence.'
  }, {
    year: '2015',
    title: 'Expansion',
    description: 'Launched our catering division and opened three new restaurant concepts.'
  }, {
    year: '2020',
    title: 'Awards & Recognition',
    description: 'Recognized as the top hospitality group in the region for service and innovation.'
  }, {
    year: '2026',
    title: 'Future Growth',
    description: 'Expanding our footprint with new real estate acquisitions and corporate memberships.'
  }];
  return <div className="bg-white" data-id="element-401">
      <PageHero title="About Us" subtitle="Honest food, warm hospitality, and a deep sense of community." backgroundImage="https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?w=1920&q=80" data-id="element-402" />

      {/* Who We Are */}
      <section className="py-24 md:py-32 relative" data-id="element-403">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-404">
          <motion.h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-405">
            Who We Are
          </motion.h2>
          <motion.div className="w-16 h-1 bg-brand-terracotta mx-auto mb-10" initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} data-id="element-406" />
          <motion.p className="text-lg md:text-xl text-brand-dark/80 font-light leading-relaxed mb-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-407">
            Jibek Jolu Group is a premier hospitality company dedicated to
            creating extraordinary dining and event experiences. Rooted in the
            rich traditions of Central Asia, we blend time-honored culinary
            techniques with modern innovation.
          </motion.p>
          <motion.p className="text-lg md:text-xl text-brand-dark/80 font-light leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-408">
            Our mission is simple: to bring people together over exceptional
            food in beautiful spaces. From our flagship restaurants to our
            large-scale catering operations, every concept is united by our
            commitment to quality, integrity, and genuine hospitality.
          </motion.p>
        </div>
      </section>

      {/* Milestones */}
      <section className="py-24 md:py-32 bg-brand-beige relative overflow-hidden" data-id="element-409">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-410"></div>
        <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-411">
          <div className="text-center mb-20" data-id="element-412">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-413">
              Our Journey
            </h2>
            <div className="w-16 h-1 bg-brand-red mx-auto" data-id="element-414"></div>
          </div>

          <div className="space-y-16" data-id="element-415">
            {milestones.map((milestone, index) => <motion.div key={index} className="flex flex-col md:flex-row gap-6 md:gap-12 items-start" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6
          }} data-id="element-416">
                <div className="md:w-1/4 shrink-0" data-id="element-417">
                  <span className="text-4xl md:text-5xl font-serif text-brand-red font-bold" data-id="element-418">
                    {milestone.year}
                  </span>
                </div>
                <div className="md:w-3/4 border-l-2 border-brand-dark/10 pl-6 md:pl-10 pb-8" data-id="element-419">
                  <h3 className="text-2xl font-serif text-brand-dark mb-4" data-id="element-420">
                    {milestone.title}
                  </h3>
                  <p className="text-brand-dark/70 font-light text-lg" data-id="element-421">
                    {milestone.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Stats & CTA */}
      <section className="py-24 md:py-32 bg-brand-dark text-white text-center relative" data-id="element-422">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-423"></div>
        <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10" data-id="element-424">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-20" data-id="element-425">
            {[{
            value: '6',
            label: 'Restaurants'
          }, {
            value: '4',
            label: 'Major Brands'
          }, {
            value: '30k+',
            label: 'Guests Monthly'
          }, {
            value: '150+',
            label: 'Team Members'
          }].map((stat, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-426">
                <div className="text-5xl md:text-6xl font-serif text-brand-gold mb-4" data-id="element-427">
                  {stat.value}
                </div>
                <div className="text-sm uppercase tracking-[0.2em] text-white/60" data-id="element-428">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>

          <Link to="/concepts/restaurants" className="inline-block border border-brand-gold text-brand-gold px-10 py-4 uppercase tracking-[0.2em] text-sm hover:bg-brand-gold hover:text-brand-dark transition-colors duration-300" data-id="element-429">
            Explore Our Concepts
          </Link>
        </div>
      </section>
    </div>;
}